import "./index.scss";

import { MenuItem } from "@mui/material";
import { Box } from "@mui/system";
import { Phrases } from "assets/strings/phrases";
import ConfirmationBox from "components/ConfirmationBox";
import ScreenLoader from "components/ScreenLoader";
import { GENERIC_MEMBER_STATUS_OPTIONS } from "constants/index";
import { TMemberDetails } from "models/member";
import { updateMemberStatus } from "modules/member/memberServices";
import { useMemo, useState } from "react";
import { toast } from "react-toastify";

import MemberPersonalInfoStatusDropdown from "./MemberPersonalInfoStatusDropdown";

export default function StatusSection(props: { member: TMemberDetails; editCallback: any }) {
  const { member, editCallback } = props;
  const [loading, setLoading] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(member?.status);

  const memberStatusOptions = useMemo(() => {
    return GENERIC_MEMBER_STATUS_OPTIONS.map(
      (e, index) =>
        !e.isSelectAll && (
          <MenuItem
            key={`statusddlentry_${index}`}
            // selected={e.value === status}
            value={e.value}
          >
            {e.label}
          </MenuItem>
        )
    );
  }, []);

  const [confirmationBoxShown, setConfirmationBoxShown] = useState(false);
  const [confirmationBoxMainTitle, setConfirmationBoxMainTitle] = useState("");
  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState("");
  const [confirmationBoxMessage, setConfirmationBoxMessage] = useState(<></>);
  const [confirmationBoxType, setConfirmationBoxType] = useState<"confirmation" | "alert" | "info">(
    "confirmation"
  );
  const [confirmationBoxOnClose, setConfirmationBoxOnClose] = useState(() => void 0);
  const [confirmationBoxIsLoading, setConfirmationBoxIsLoading] = useState(false);

  const showReclaimIdPopup = (id) => {
    //console.log(`onUpdateStatusIdCheck Member is ${JSON.stringify({ ...member })}`);
    setConfirmationBoxMainTitle(Phrases.tcaNewIdNeededTitle);
    setConfirmationBoxTitle(Phrases.tcaNewIdNeededMessage);
    setConfirmationBoxMessage(
      <Box mt={2} mx={2}>
        <ul>
          <li>
            {Phrases.tcaNewIdNeededYes}
            <br />
            <br />
          </li>
          <li>{Phrases.tcaNewIdNeededNo}</li>
        </ul>
      </Box>
    );
    setConfirmationBoxOnClose((_prev, _props) => {
      return (v) => {
        if (typeof v !== "boolean") {
          setConfirmationBoxShown(false);
        }
        if (v) {
          //Positive response
          console.log("Yes clicked");
          editCallback(id);
          setConfirmationBoxShown(false);
        } else {
          setConfirmationBoxShown(false);
        }
      };
    });
    setConfirmationBoxShown(true);
  };

  return (
    <>
      <p className="title status-section-title">Status</p>
      {loading && <ScreenLoader isScreenLoader />}
      {!loading && (
        <MemberPersonalInfoStatusDropdown
          name="status"
          label="Status"
          className="base-dropdown-member-personal-info"
          shrink={false}
          value={currentStatus}
          defaultValue={currentStatus ?? ""}
          onChange={(v) => {
            if (
              member?.membership.fitlinxx_id.length > 5 &&
              (currentStatus === "TERMINATED" || currentStatus === "TERMINATED_FACILITY")
            ) {
              console.log(`This user is inactive and has a reclaimed ID`);
              showReclaimIdPopup(member?.membership.member_id);
            } else {
              console.log(`Setting status to ${v.target.value}`);
              setLoading(true);
              updateMemberStatus({
                member_id: member?.membership.member_id,
                member_status: v.target.value,
              })
                .then((result) => {
                  if (result.success) {
                    //show success message
                    toast("Member state updated successfully", { type: "success" });
                    setCurrentStatus(v.target.value.toString());
                  } else {
                    toast("Member state update failed", { type: "error" });
                  }
                })
                .catch((e) => {
                  toast("Member state update failed", { type: "error" });
                })
                .finally(() => setLoading(false));
            }
          }}
        >
          {memberStatusOptions}
        </MemberPersonalInfoStatusDropdown>
      )}
      <ConfirmationBox
        open={confirmationBoxShown}
        onClose={confirmationBoxOnClose}
        mainTitle={confirmationBoxMainTitle}
        title={confirmationBoxTitle}
        message={confirmationBoxMessage}
        type={confirmationBoxType}
        isLoading={confirmationBoxIsLoading}
      />
    </>
  );
}
